import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { I18n } from 'react-redux-i18n';
import { Provider } from '../../common/ComponentIdContext';
import {
  withComponentName,
  ComponentNameProvider,
} from '../../common/ComponentNameContext';
import { withComponentId } from '../../common/ComponentIdContext';
import ConstCommon from '../../common/Const';
import { COMPONENT_RESIZE } from '../../common/GoldenLayoutWrapper';
import ScrollComponent from '../../common/ScrollComponent';
import GroupButton from '../common/header/group-button';
import { TIME_FILTERS } from '../financial-statement/Const';
import Header from './Header';
import Notice from './notifications';
import ScoreBox from './score-box';
import SearchBox from './search-box';
import FinancialRatioTable from './Table';
import { REDUCER_NAME } from './reducer';

class FinancialRatioContent extends PureComponent {
  state = {
    width: null,
  };
  widthTrackerRef = React.createRef();

  componentDidMount() {
    this.calcWidth();
    window.addEventListener(COMPONENT_RESIZE, this.calcWidth);
  }

  componentWillUnmount() {
    const { id, unmountComponent } = this.props;
    unmountComponent(id);
    window.removeEventListener(COMPONENT_RESIZE, this.calcWidth);
  }

  calcWidth = () => {
    setTimeout(() => {
      if (!this.widthTrackerRef.current) {
        return;
      }
      const width = this.widthTrackerRef.current.closest('.lm_content')
        .clientWidth;
      if (width > 0) {
        this.setState({
          width,
        });
      }
    }, 0);
  };

  getTableWidth = () => {
    const { width } = this.state;

    return width - 40; //minus padding
  };

  renderFooter = () => {
    const { timeFilter, locale } = this.props;
    const i18nKey =
      timeFilter === TIME_FILTERS.YEARLY
        ? 'financialAnalysis.financialRatio.footerNoteYearly'
        : 'financialAnalysis.financialRatio.footerNote';
    return (
      <div>
        <div className="footer-note mt-10">{I18n.t(i18nKey)}</div>
        <div
          className={`industry-note ${locale} ${
            timeFilter === TIME_FILTERS.YEARLY ? 'yearly' : 'quarterly'
          }`}
        >
          {I18n.t('financialAnalysis.financialRatio.industryNote')}
        </div>
      </div>
    );
  };

  render() {
    const { width } = this.state;
    const { id, searchParams } = this.props;

    return (
      <ComponentNameProvider value={ConstCommon.listComponent.FinancialRatio}>
        <Provider value={id}>
          <ScrollComponent appendClassName="financial-ratio-wrapper">
            <div className="pt-8 px-20 fa-content d-flex flex-column h-100">
              <div className="d-flex flex-column flex-fill">
                <div className="fa-top-content">
                  <div className="d-flex align-items-center">
                    <SearchBox />
                    <ScoreBox />
                    <GroupButton code={searchParams.displayCode} />
                    <Notice id={id} />
                  </div>
                </div>
                <div className="fa-body-content d-flex flex-column flex-fill mb-10">
                  <Header />
                  <div
                    style={{ minHeight: 165 }} //Fix responsive safari
                    ref={this.widthTrackerRef}
                    className="d-flex flex-column flex-fill"
                  >
                    {width && (
                      <FinancialRatioTable width={this.getTableWidth()} />
                    )}
                  </div>
                  {this.renderFooter()}
                </div>
              </div>
            </div>
          </ScrollComponent>
        </Provider>
      </ComponentNameProvider>
    );
  }
}

const mapStateToProps = (state, { id }) => {
  return {
    searchParams: state[REDUCER_NAME][id].searchParams,
  };
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    null,
  ),
)(FinancialRatioContent);
